// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___10cPK","title":"styles__title___1pZEH","button":"styles__button___3gY9K","content":"styles__content___1EiKm"};